import { Box } from '@mui/material';
import { CVBuilderFormKeys, EducationEntry } from 'utils/cv-form-db';
import { EditModeNavigationButtons } from '../../components/EditModeNavigationButtons';
import { PreviousStepNavigationButton } from '../../components/PreviousStepNavigationButton';
import { StepNavigationButton } from '../../components/StepNavigationButton';
import { RootBox } from '../../components/styledComponents';
import { useCVStepActions } from '../../hooks';
import { useEditModeNavigation } from '../../hooks/useEditModeNavigation';
import DeleteEducationModal from './DeleteEducationModal';
import { EducationContent } from './EducationContent';
import { compareSemesters } from './utils';

export const EducationStep = () => {
  const { isEditMode } = useEditModeNavigation();
  const {
    isFormOpen,
    isEditing,
    editingItem,
    deleteModalState,
    handleAdd,
    handleEdit,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete,
    handleEditClick,
    handleAddClick,
    handleCancelForm
  } = useCVStepActions<EducationEntry>({
    fieldName: CVBuilderFormKeys.EDUCATION,
    sortFunction: (a, b) =>
      compareSemesters(b.studyStart || '', a.studyStart || ''),
    disableAutoSave: isEditMode
  });

  if (isEditMode) {
    return (
      <RootBox
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <EducationContent
          isFormOpen={isFormOpen}
          isEditing={isEditing}
          editingItem={editingItem || null}
          onAdd={handleAdd}
          onEdit={handleEdit}
          onCancel={handleCancelForm}
          onAddClick={handleAddClick}
          onEditClick={handleEditClick}
          onDeleteClick={handleDeleteClick}
        />
        <Box sx={{ flex: 1 }} />
        {!isFormOpen && <EditModeNavigationButtons />}
        <DeleteEducationModal
          isOpen={deleteModalState.isOpen}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      </RootBox>
    );
  }

  return (
    <RootBox
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <EducationContent
        isFormOpen={isFormOpen}
        isEditing={isEditing}
        editingItem={editingItem || null}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onCancel={handleCancelForm}
        onAddClick={handleAddClick}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
      />
      <Box sx={{ flex: 1 }} />
      {!isFormOpen && (
        <>
          <StepNavigationButton step="EDUCATION" />
          <PreviousStepNavigationButton step="EDUCATION" />
        </>
      )}
      <DeleteEducationModal
        isOpen={deleteModalState.isOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
      />
    </RootBox>
  );
};
